export default __webpack_public_path__ + "ba1b04a.png";